module.exports = __webpack_public_path__ + "img/map-badge-hide.47bb8733.svg";